<template>
    <div id="app"
         v-loading.fullscreen.lock="isLoading"
         element-loading-text="Carregando Dados..."
         element-loading-background="rgba(0, 0, 0, .8)">
        <AppHeader v-if="isLogged"></AppHeader>
        <AppSidebar v-if="isLogged"></AppSidebar>
        <div class="app-content">
            <div :class="{ 'container': isLogged }">
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
  import AppHeader from './components/main/Header.vue'
  import AppSidebar from './components/main/Sidebar.vue'
  import {mapGetters, mapActions} from 'vuex'
  import bus from '@utils/bus'

  export default {
    name: 'App',
    components: {AppHeader, AppSidebar},
    computed: {
      ...mapGetters(['isLogged', 'isLoading'])
    },
    methods: {
      ...mapActions(['showLoader', 'hideLoader'])
    },
    mounted () {
      bus.$on('show-loader', () => this.showLoader())
      bus.$on('hide-loader', () => this.hideLoader())
    }
  }
</script>

<style src="assets/sass/app.scss" lang="scss"></style>
<style src="assets/sass/responsive.scss" lang="scss"></style>



// WEBPACK FOOTER //
// Main.vue?49f9b3e5